<div class="row button-container">
    <div class="col-2 custom-button">
        <div *ngIf="column.includes('DtlEnabled')" class="signifyBookmd">
            <label class="enable-feature" aria-hidden="true">Enable feature
                <input type="checkbox" [checked]="DtlEnabledval" [(ngModel)]="ngModelval['DtlEnabled']"
                    name="DtlEnabled" class="primary-checkbox" id="DtlEnabled"
                    (change)="rSetChanged($event.target.checked)" />
                <span id="DTL-enableFeature-checkbox" class="extra-border-enablefeat"></span>
            </label>
        </div>

        <!--External-->
    </div>
    <span class="col-1 aoc-tooltips" *ngIf="dtlDefaultColor===false">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Restore default</div>
            </div>
        </ng-template>
    </span>
    <span class="col-1 aoc-tooltips" *ngIf="dtlDefaultColor===true">
        <ng-template #restoreDefault>
            <div class="row app-area-container">
                <div class="col-9 title-tooltip">Default</div>
            </div>
        </ng-template>
    </span>

    <div class="col-8"></div>
    <div class="col-1"></div>
</div>
<div class="row unit-container">
    <div class="col-2 custom-button"></div>
    <div class="col-1"></div>
</div>

<!--Dim Start Begain-->
<div id="DTL-startDim-section" *ngIf="column.includes('DtlDimStart') " class="row slider-container" [ngClass]="{'dtldisbaled': dtldisbaled}">
    <div id="DTL-startDim-label" class="col-1 label signifyBookmd text-mindim dim-margin">Start dim</div>
    <span id="DTL-startDim-min" class="signifyBookmd text-mindim  sliderMinValue col-1" *ngIf="!quickConfigvalue">{{DtlDimStartMin}}</span>

    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin flex-column">
                <span class=" signifyBookmd minValue">min</span>
                <span class=" signifyBookmd minValue">  {{ DtlDimStartMin }}</span>
            </div>
            <div class="col-2 flex-column">
                <span class=" signifyBookmd minValue">max</span>
                <span class="signifyBookmd maxValue"> {{ DtlDimStartMax }}</span>
            </div>
        </div>
    </div>

    <div class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue"
        [ngClass]="{'disbaleStyle': dtldisbaled}">
        <ngx-slider [options]=DtlDimStartOption (mouseup)="sliderEvent(formControl.value)" [(ngModel)]=DtlDimStartVal
            (userChangeEnd)="dimStartSlideValuechange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span id="DTL-startDim-max" class="signifyBookmd text-mindim  col-1 maxValueCss" *ngIf="!quickConfigvalue">{{DtlDimStartMax}}</span>
    <div class="col-3 d-flex align-items-center" style="margin-left: -1em;">
        <input type="text" [value]="DtlDimStartDisplayValue"
            (input)="onFieldInput($event.target.value, 'DtlDimStart')"
            (blur)="onFieldBlur('DtlDimStart')"
            (keypress)="numberOnly($event)" id="dtl_StartDim_txtbox"
            [ngClass]="{'showingError': inputError['DtlDimStart']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true,'dtldisbaled': dtldisbaled}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="dtldisbaled" />
        <p id="DTL-startDim-unit" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&deg;C</p>
    </div>
</div>
<!--Dim Start End -->


<!--Dim Stop Begain-->
<div id="DTL-stopDim-section" *ngIf="column.includes('DtlDimStop') " class="row slider-container" [ngClass]="{'dtldisbaled': dtldisbaled}">
    <div id="DTL-stopDim-label" class="col-1 label signifyBookmd text-mindim dim-margin">Stop dim</div>
    <span id="DTL-stopDim-min" class="signifyBookmd text-mindim  sliderMinValue col-1" *ngIf="!quickConfigvalue">{{DtlDimStopMin}}</span>

    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin flex-column">
                <span class=" signifyBookmd minValue">min</span>
                <span class=" signifyBookmd minValue">  {{ DtlDimStopMin }}</span>
            </div>
            <div class="col-2 flex-column">
                <span class=" signifyBookmd minValue">max</span>
                <span class="signifyBookmd maxValue">  {{ DtlDimStopMax }}</span>
            </div>
        </div>
    </div>

    <div class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue"
        [ngClass]="{'disbaleStyle': dtldisbaled}">
        <ngx-slider type="dtlstop" [options]=DtlDimStopOption [(ngModel)]="DtlDimStopVal"
            (mouseup)="sliderEvent(formControl.value)" (userChangeEnd)="dtlStopsliderChangeMinLim(formControl.value)"
            (userChangeEnd)="dimStopSlideValuechange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span id="DTL-stopDim-max" class="signifyBookmd text-mindim  col-1 maxValueCss" *ngIf="!quickConfigvalue">{{DtlDimStopMax}}</span>
    <div class="col-3 d-flex align-items-center" style="margin-left: -1em;">
        <input type="text" [value]="DtlDimStopDisplayValue"
            (input)="onFieldInput($event.target.value, 'DtlDimStop')"
            (blur)="onFieldBlur('DtlDimStop')"
            (keypress)="numberOnly($event)" id="dtl_StopDim_txtbox"
            [ngClass]="{'showingError': inputError['DtlDimStop']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true,'dtldisbaled': dtldisbaled}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="dtldisbaled" />
        <p id="DTL-stopDim-unit" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&deg;C</p>
    </div>
</div>
<!--Dim Stop End -->


<!--shutdown Begin-->
<div id="DTL-shutdown-section" *ngIf="column.includes('DtlLampOff') " class="row slider-container" [ngClass]="{'dtldisbaled': dtldisbaled}">
    <div id="DTL-shutdown-label" class="col-1 label signifyBookmd text-mindim dim-margin">Shutdown</div>
    <span id="DTL-shutdown-min" class="signifyBookmd text-mindim  sliderMinValue col-1" *ngIf="!quickConfigvalue">{{DtlLampOffMin}}</span>

    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin flex-column">
                <span class=" signifyBookmd minValue">min</span>
                <span class=" signifyBookmd minValue">  {{ DtlLampOffMin }}</span>
            </div>
            <div class="col-2 flex-column">
                <span class=" signifyBookmd minValue">max</span>
                <span class="signifyBookmd maxValue">  {{DtlLampOffMax }}</span>
            </div>
        </div>
    </div>

    <div class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue"
        [ngClass]="{'disbaleStyle': DtlLampOffDisbaled || dtldisbaled}">
        <ngx-slider [options]=DtlLampOffOption [(ngModel)]=DtlLampOffVal (mouseup)="sliderEvent(formControl.value)"
            (userChangeEnd)="DtlLampOffSlideValuechange($event.value)" ngDefaultControl>
        </ngx-slider>
    </div>
    <span id="DTL-shutdown-max" class="signifyBookmd text-mindim  col-1 maxValueCss" *ngIf="!quickConfigvalue">{{DtlLampOffMax}}</span>
    <div class="col-3 d-flex align-items-center" style="margin-left: -1em;">
        <input type="text" [value]="DtlLampOffDisplayValue"
            (input)="onFieldInput($event.target.value, 'DtlLampOff')"
            (blur)="onFieldBlur('DtlLampOff')"
            (keypress)="numberOnly($event)" id="dtl_Shutdown_txtbox"
            [ngClass]="{'showingError': inputError['DtlLampOff']===true, 'disbaleStyle': isExternalRset, 'dtldisbaled': dtldisbaled,'inputCssStandard': quickConfigvalue===true}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="DtlLampOffDisbaled || dtldisbaled" />
        <p id="DTL-shutdown-unit" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">&deg;C</p>
    </div>
    <div class="col-1" *ngIf="!quickConfigvalue"></div>
    <div class="col-3 signifyBookmd sliderMinValue" [ngClass]="{'disabledStandard': quickConfigvalue===true}">
        <label class="enable-feature" aria-hidden="true">Disabled
            <input type="checkbox" [checked]="DtlLampOffDisabledVal" [(ngModel)]="ngModelval['DtlLampOffDisabled']"
                name="dtlDisabled" class="primary-checkbox" id="dtlDisabled"
                [ngClass]="{'dtldisbaled': dtldisbaled, 'inputCssStandard': quickConfigvalue===true}"
                (change)="lampOffDisabled($event.target.checked)" [disabled]="dtldisbaled" />
            <span id="DTL-shutdown-disabled-checkbox" class="extra-border-enablefeat"></span>
        </label>
    </div>
</div>
<!--Shut down End -->


<!--Derating Begain-->
<div id="DTL-derating-section" *ngIf="column.includes('DtlOutputPercentage') " class="row slider-container"
    [ngClass]="{'dtldisbaled': dtldisbaled}">
    <div id="DTL-derating-label" class="col-1 label signifyBookmd text-mindim dim-margin">Derating dim level</div>
    <span id="DTL-derating-min" class="signifyBookmd text-mindim  sliderMinValue col-1"
        *ngIf="!quickConfigvalue">{{DtlOutputPercentageMin}}</span>

    <div class="col-2" *ngIf="quickConfigvalue">
        <div class="row">
            <div class="col-2"></div>
            <div class="col-2 minValMargin flex-column">
                <span class=" signifyBookmd minValue">min</span>
                <span [id]="'DTL-derating-min'" class=" signifyBookmd minValue">  {{ DtlOutputPercentageMin }}</span>
            </div>
            <div class="col-2 flex-column">
                <span class=" signifyBookmd minValue">max</span>
                <span id="DTL-derating-max" class="signifyBookmd maxValue">  {{ DtlOutputPercentageMax }}</span>
            </div>
        </div>
    </div>

    <div class="col-6 curvePadding sliderCss" *ngIf="!quickConfigvalue"
        [ngClass]="{'disbaleStyle': dtldisbaled}">
        <ngx-slider [options]=DtlOutputPercentageOption [(value)]=DtlOutputPercentageVal
            (userChangeEnd)="DtlOutputPercentageSlideValuechange($event.value)" (mouseup)="sliderEvent(formControl.value)"
            ngDefaultControl>
        </ngx-slider>
    </div>
    <span [id]="'DTL-derating-max'" class="signifyBookmd text-mindim  col-1 maxValueCss"
        *ngIf="!quickConfigvalue">{{DtlOutputPercentageMax}}</span>
    <div class="col-3 d-flex align-items-center" style="margin-left: -1em;">
        <input type="tel" [value]="DtlOutputPercentageDisplayValue"
            (input)="onFieldInput($event.target.value, 'DtlOutputPercentage')"
            (blur)="onFieldBlur('DtlOutputPercentage')"
            (keypress)="numberOnly($event)"
            id="dtl_Deratingdimlevel_txtbox"
            [ngClass]="{'showingError': inputError['DtlOutputPercentage']===true, 'disbaleStyle': isExternalRset, 'inputCssStandard': quickConfigvalue===true,'dtldisbaled': dtldisbaled}"
            class="input-text form-control signifyBookmd {{ quickConfigCustomCSS }} textbox-standard"
            [disabled]="dtldisbaled" />
        <p id="DTL-derating-unit" class="signifyBookmd mb-0 ml-2" [ngClass]="[!quickConfigvalue ? 'unit' : 'quick-unit']">%</p>
    </div>
</div>
<!--Derating dim End -->

<!---DTL graph start-->
<app-dtl-graph id="DTL-graph" [ngClass]="dtldisbaled ? 'graph-disable' : 'graph-enable'" *ngIf="!quickConfigvalue"></app-dtl-graph>
<!---DTL grpah end-->
